class RecentlyViewed extends HTMLElement {

    /**
     * This component stores the product handle in a cookie and also 
     * handles the display of a widget that iterates through those product handles
     * and calls the PDP via ajax to load those products in product cards
     */
    constructor() {
        super();

        this.mode = this.dataset.mode;
        this.wrapperSelector = this.dataset.wrapperSelector;
        this.howManyToShow = parseInt(this.dataset.maxItems);
        this.maxStoreItems = parseInt(this.dataset.maxItemsStore);
        this.layoutMode = this.dataset.layout;
        // Desktop
        this.sliderLoop = this.dataset.sliderLoop == 'true';
        this.sliderCentered = this.dataset.sliderCentered == 'true';
        this.sliderMaxSlides = parseFloat(this.dataset.sliderSlides);
        this.sliderShowDots = this.dataset.sliderDots == 'true';
        this.sliderShowArrows = this.dataset.sliderArrows == 'true';
        this.sliderAutoplay = this.dataset.sliderAutoplay == 'true';
        this.sliderAutoplayDuration = parseInt(this.dataset.sliderAutoplayDuration);
        this.sliderSpacing = parseInt(this.dataset.sliderSpacing);
        // Tablet
        this.sliderLoopTablet = this.dataset.sliderLoopTablet == 'true';
        this.sliderCenteredTablet = this.dataset.sliderCenteredTablet == 'true';
        this.sliderMaxSlidesTablet = parseFloat(this.dataset.sliderSlidesTablet);
        this.sliderShowDotsTablet = this.dataset.sliderDotsTablet == 'true';
        this.sliderShowArrowsTablet = this.dataset.sliderArrowsTablet == 'true';
        this.sliderAutoplayTablet = this.dataset.sliderAutoplayTablet == 'true';
        this.sliderAutoplayDurationTablet = parseInt(this.dataset.sliderAutoplayDurationTablet);
        this.sliderSpacingTablet = parseInt(this.dataset.sliderSpacingTablet);
        // Mobile
        this.sliderLoopMobile = this.dataset.sliderLoopMobile == 'true';
        this.sliderCenteredMobile = this.dataset.sliderCenteredMobile == 'true';
        this.sliderMaxSlidesMobile = parseFloat(this.dataset.sliderSlidesMobile);
        this.sliderShowDotsMobile = this.dataset.sliderDotsMobile == 'true';
        this.sliderShowArrowsMobile = this.dataset.sliderArrowsMobile == 'true';
        this.sliderAutoplayMobile = this.dataset.sliderAutoplayMobile == 'true';
        this.sliderAutoplayDurationMobile = parseInt(this.dataset.sliderAutoplayDurationMobile);
        this.sliderSpacingMobile = parseInt(this.dataset.sliderSpacingMobile);

        this.wrapper = this.querySelector(this.wrapperSelector);
        this.slider = null;

        this.onComplete = null;
        this.productHandleQueue = null;
        this.productHandles = null;
        this.productData = [];
        this.loading = 0;
        this.shown = 0;

        this.cookie = {
            configuration: {
                expires: 90,
                path: "/",
                domain: window.location.hostname
            },
            name: "shopify_recently_viewed",
            write: function (recentlyViewed) {
                Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
            },
            read: function () {
                var recentlyViewed = [];
                var cookieValue = Cookies.get(this.name);
                if (cookieValue && cookieValue !== null) {
                    recentlyViewed = cookieValue.split(" ");
                }
                return recentlyViewed;
            },
            destroy: function () {
                Cookies.remove(this.name);
            },
            remove: function (productHandle) {
                var recentlyViewed = this.read();
                var position = recentlyViewed.findIndex(p => p == productHandle);
                if (position !== -1) {
                    recentlyViewed.splice(position, 1);
                    this.write(recentlyViewed);
                }
            },
        };

        /**
         * Starting in different modes:
         * Record: it only stores the product without displaying any widget. It is intended to work only in PDP
         * Display + Record: it stores the product and it displays the widget. It is intended to work only in PDP
         * Display (Default): It displays the widget with recent products. It can be added to any page
         */

        if (this.mode == 'record') {
            this.recordRecentlyViewed();
        }
        else if (this.mode == 'display_record') {
            this.recordRecentlyViewed();
            this.showRecentlyViewed();
        }
        else
            this.showRecentlyViewed();
    }

    showRecentlyViewed() {
        this.productHandleQueue = this.cookie.read();
        this.productHandles = this.productHandleQueue.map(function(x) { return x;});
        var howManyToShow = Math.min(this.productHandleQueue.length, this.howManyToShow);
        if (howManyToShow && this.wrapper != null) {
            this.nextQueue();
        }
      if(this.cookie.read().length <4){
        document.querySelector(".recently-viewed-prods").classList.add("hide");
      }else{
        document.querySelector(".section-featured-home").classList.add("hide");
      }
    }

    nextQueue() {
        var self = this;
        if (this.productHandleQueue.length && (this.shown + this.loading) < this.howManyToShow) {
            var itemHandle = this.productHandleQueue[0];
            if (window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)) {
                var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
            } else {
                var productHandle = null;
            }
            if (productHandle != itemHandle) {
                self.loading++;
                $s.getJson({
                    url: '/products/' + itemHandle + '?sections=product_card_ajax',
                    success: function (data) {
                        self.loading--;
                        var html = data.product_card_ajax ? data.product_card_ajax : '';
                        if (html.indexOf('product-card') > 0) {
                            var ajaxHTML = self.extractCard(html);
                                ajaxHTML = ajaxHTML.replace('display-mode-internal', (self.layoutMode == 'grid' ? 'grid-item' : 'keen-slider-slide'));
                            self.productData[itemHandle] = ajaxHTML;
                            self.shown++;
                        } else {
                            self.cookie.remove(itemHandle);
                        }
                        if (self.loading == 0) {
                          self.finalize();
                        }
                    },
                    error: function(response) {
                        self.loading--;
                        self.cookie.remove(itemHandle);
                        self.nextQueue();
                        if (self.loading == 0) {
                          self.finalize();
                        }
                    },
                });
            }
            self.productHandleQueue.shift();
            self.nextQueue();
        }
    }

    finalize() {
        var html = ''; 
        for (var i=0; i<this.productHandles.length; i++) {
            if (this.productData[this.productHandles[i]]) {
                html += this.productData[this.productHandles[i]];
            }
        }
        this.wrapper.innerHTML += html;
        this.classList.remove('hide');
        if (this.layoutMode == 'carousel')
            this.initCarousel();
        if (this.onComplete) {
            try {
                this.onComplete();
            } catch (error) {}
        }
    }

    initCarousel() {
        var sliderWrapper = this.querySelector('.keen-slider');
        this.slider = new KeenSlider(sliderWrapper, {
            mode: "snap",
            loop: this.sliderLoop,
            centered: this.sliderCentered,
            dots: this.sliderShowDots ? document.querySelector('.keen-dots') : false,
            prevButton: this.sliderShowArrows ? sliderWrapper.parentNode.parentNode.querySelector('.keen-arrow.prev') : '',
            nextButton: this.sliderShowArrows ? sliderWrapper.parentNode.parentNode.querySelector('.keen-arrow.next') : '',
            autoplay: this.sliderAutoplay,
            duration: this.sliderAutoplayDuration,
            slidesPerView: this.sliderMaxSlides,
            spacing: this.sliderSpacing,
            breakpoints: {
                '(max-width: 900px)': {
                    loop: this.sliderLoopTablet,
                    centered: this.sliderCenteredTablet,
                    dots: this.sliderShowDotsTablet ? document.querySelector('.keen-dots') : false,
                    prevButton: this.sliderShowArrowsTablet ? sliderWrapper.parentNode.parentNode.querySelector('.keen-arrow.prev') : '',
                    nextButton: this.sliderShowArrowsTablet ? sliderWrapper.parentNode.parentNode.querySelector('.keen-arrow.next') : '',
                    autoplay: this.sliderAutoplayTablet,
                    duration: this.sliderAutoplayDurationTablet,
                    slidesPerView: this.sliderMaxSlidesTablet,
                    spacing: this.sliderSpacingTablet,
                },
                '(max-width: 600px)': {
                    loop: this.sliderLoopMobile,
                    centered: this.sliderCenteredMobile,
                    dots: this.sliderShowDotsMobile ? document.querySelector('.keen-dots') : false,
                    prevButton: this.sliderShowArrowsMobile ? sliderWrapper.parentNode.parentNode.querySelector('.keen-arrow.prev') : '',
                    nextButton: this.sliderShowArrowsMobile ? sliderWrapper.parentNode.parentNode.querySelector('.keen-arrow.next') : '',
                    autoplay: this.sliderAutoplayMobilet,
                    duration: this.sliderAutoplayDurationMobile,
                    slidesPerView: this.sliderMaxSlidesMobile,
                    spacing: this.sliderSpacingMobile,
                }
            }
        });
    }


    extractCard (data) {
        var m = data.match(/<div class="ajax-item display-mode-internal">(.?\s*)*<\/div>/gi);
        return m.length > 0 ? m[0] : '';
    }

    recordRecentlyViewed() {
        var recentlyViewed = this.cookie.read();
        if (window.location.pathname.indexOf("/products/") !== -1) {
            var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
            var position = recentlyViewed.indexOf(productHandle);
            if (position === -1) {
                recentlyViewed.unshift(productHandle);
                recentlyViewed = recentlyViewed.splice(0, this.maxStoreItems);
            } else {
                recentlyViewed.splice(position, 1);
                recentlyViewed.unshift(productHandle);
            }
            this.cookie.write(recentlyViewed);
        }
    }

    clearList () {
        this.cookie.destroy();
    }
}
customElements.define('recently-viewed', RecentlyViewed);